import TableSkeletonItem from './TableSkeletonItem';

export default TableSkeletonItem;
